import gql from "graphql-tag";

export const ShareOpportunity = gql`
  mutation ShareOpportunity(
    $emails: [String]!
    $opportunityId: String!
    $description: String
  ) {
    shareOpportunity(
      emails: $emails
      opportunityId: $opportunityId
      description: $description
    )
  }
`;
